<a class="code">
  {{ code }}
</a>
<i class="icon ion-md-barcode" [ngStyle]="{'font-size': size}"></i>
